import React from 'react';
import { useTranslation } from 'react-i18next';

const FaultDiagnosis: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('readback.faultDiagnosis')}
      </h3>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-gray-500 dark:text-gray-400 border-b dark:border-gray-700">
            <th className="pb-2">Register</th>
            <th className="pb-2">Value</th>
            <th className="pb-2">Decode</th>
          </tr>
        </thead>
        <tbody className="text-gray-400">
          <tr><td className="py-1">CFSR</td><td className="py-1 font-mono">--</td><td className="py-1">--</td></tr>
          <tr><td className="py-1">HFSR</td><td className="py-1 font-mono">--</td><td className="py-1">--</td></tr>
          <tr><td className="py-1">MMFAR</td><td className="py-1 font-mono">--</td><td className="py-1">--</td></tr>
          <tr><td className="py-1">BFAR</td><td className="py-1 font-mono">--</td><td className="py-1">--</td></tr>
          <tr><td className="py-1">PC</td><td className="py-1 font-mono">--</td><td className="py-1">--</td></tr>
          <tr><td className="py-1">LR</td><td className="py-1 font-mono">--</td><td className="py-1">--</td></tr>
        </tbody>
      </table>
    </div>
  );
};

export default FaultDiagnosis;
